/**
 * Initials-in-circle avatar + "Verified Google Review" badge.
 * Replaces stock pravatar.cc placeholders that hurt credibility.
 */
interface GoogleReviewBadgeProps {
  name: string;
  size?: number;
  className?: string;
}

// Deterministic color from name so the same reviewer always gets the same tone.
const palette = [
  "hsl(25 90% 50%)",    // primary orange
  "hsl(210 60% 50%)",   // blue
  "hsl(150 45% 45%)",   // green
  "hsl(340 60% 55%)",   // rose
  "hsl(45 75% 50%)",    // amber
  "hsl(265 45% 55%)",   // violet
];

function initialsFrom(name: string): string {
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

function colorFrom(name: string): string {
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = (hash * 31 + name.charCodeAt(i)) | 0;
  return palette[Math.abs(hash) % palette.length];
}

export default function GoogleReviewBadge({ name, size = 40, className = "" }: GoogleReviewBadgeProps) {
  const initials = initialsFrom(name);
  const bg = colorFrom(name);
  const fontSize = Math.round(size * 0.4);
  return (
    <div
      className={`shrink-0 rounded-full flex items-center justify-center font-heading font-bold text-white select-none ${className}`}
      style={{ width: size, height: size, backgroundColor: bg, fontSize }}
      aria-label={`${name} avatar`}
    >
      {initials}
    </div>
  );
}
